export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_PASSWORD_SETTINGS = 'UPDATE_PASSWORD_SETTINGS';